export const Config = {
  DefaultBusinessAvatar: 'https://squareping.s3.us-west-2.amazonaws.com/unknown/1771778471687_default.png',
  DefaultBusinessBanner: 'https://squareping-dev.s3.us-west-2.amazonaws.com/unknown/1768620392829_Screenshot%202026-01-17%20at%2010.25.40.png',
  DefaultBusinessLogo: 'https://squareping-dev.s3.us-west-2.amazonaws.com/656d7c91d333df0011736136/1766584444212_default_bg_branding.jpg',
  getTermUrl: (language = 'en') => `https://squareping.com/license/${language}/terms.html`,
  getPolicyUrl: (language = 'en') => `https://squareping.com/license/${language}/privacy.html`,

  WebAppURL: process.env.REACT_APP_WEB_APP_URL as string,
  BaseURL: process.env.REACT_APP_BASE_URL as string,

  featureFlag: {
    requireSubscription: true,
  },
};
